import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import {withStyles} from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Typography from './Typography';

const styles = theme => ({
   errorMessage: {
      backgroundColor: `${theme.palette.error.light} !important`,
      paddingRight: theme.spacing(6),
   },
   closeButtonStyle: {
      position: 'absolute',
      right: 0,
      top: 0,
      marginLeft: 'auto',
      zIndex: 1001,
   }
});

/**
 * Component to show the error messages.
 *
 * Note:
 *    Message is the default property in values.
 *
 * Reviewed: 3/26/20
 */
class ErrorSnackbar extends Component {

   static propTypes = {
      classes: PropTypes.object.isRequired,     // Styles for the component.
      open: PropTypes.bool,                     // Indicates if the Error snackbar should be shown to the user.
      enableRefresh: PropTypes.bool,            // Indicates if the Refresh action should be shown / enabled.
      onClose: PropTypes.func,                  // Callback when the snackbar is closed.
      errorId: PropTypes.string,                // Intl ID for the error message.
      message: PropTypes.string,                // Text for the error message.
      values: PropTypes.object,                 // Value object for the error message.
      actions: PropTypes.array,                 // Actions nodes to add to the Snackbar.
   };

   static defaultProps = {
      enableRefresh: true,
      values: {message : 'N/A'},
      actions: [],
   };

   /**
    * Force a browser reload.
    */
   handleRefresh = () => {
      window.location.reload(true);
   };

   render() {
      const { classes, open, onClose, errorId, values, message, enableRefresh, actions } = this.props;

      return (
         <Snackbar
            open={open}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            ContentProps={{
               'aria-describedby': 'message-id',
               classes: {
                  root: classes.errorMessage,
               }
            }}
            message={<Typography id={errorId} values={values} color={'inherit'}>{message}</Typography>}
            action={ [
               ...actions,
               enableRefresh && <Button key='undo' color='inherit' size='small' onClick={this.handleRefresh}>
                  <Typography color='inherit' id='refresh'>Refresh</Typography>
               </Button>,
               onClose && (
                  <IconButton
                     key='close'
                     aria-label='Close'
                     color='inherit'
                     className={classes.closeButtonStyle}
                     onClick={onClose}
                  >
                     <CloseIcon/>
                  </IconButton>
               ),
            ]}
         />
      );
   }
}

export default withStyles(styles)(ErrorSnackbar);
